export const soilClassificationConstants = {
  // 取得列表資料
  GET_LIST_REQUEST: "SOIL_CLASSIFICATION_GET_LIST_REQUEST",
  GET_LIST_SUCCESS: "SOIL_CLASSIFICATION_GET_LIST_SUCCESS",
  GET_LIST_FAILURE: "SOIL_CLASSIFICATION_GET_LIST_FAILURE",
  RESET_LIST_SUCCESS: "SOIL_CLASSIFICATION_RESET_LIST_SUCCESS"
};
